import {Box, Button, Grid, Paper, Typography} from '@mui/material';
import React, {useContext, useEffect, useState} from 'react';
import { AppContext } from '@/utils/appContext';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { useNavigate } from 'react-router-dom';
import SelectDateField from './SelectDateField';
import SetGuestsField from './SetGuestsField';
import SetCouponField from './SetCouponField';
import SelectDestinationField from './SelectDestinationField';
import {MagnifyingGlass, TicketCoupon, XmarkCircle} from "@vectopus/atlas-icons-react";
import { Close } from '@mui/icons-material';
import CloseIcon from "@mui/icons-material/Close";
import {g, website} from '@/utils/helpers';

const useStyles = makeStyles()((theme) => {
  return {
    root: {
      backgroundColor: '#FFFFFF',
      padding: '15px 32px',
      boxShadow: '0px 3px 6px #00000029',
      position: 'sticky',
      top: 0,
      zIndex: 9999999
    },
    inputPaper: {
      backgroundColor: '#F5F5F5',
      marginTop: '2px',
      '&:nth-of-type(even)': {
        borderLeft: '2px solid #FFFFFF',
        borderRight: '2px solid #FFFFFF'
      },
      h6: {
        fontFamily: theme.typography.body1.fontFamily
      }
    },
    fieldContent: {
      padding: '8px 5px',
      display: 'inline-flex',
      alignItems: 'center',
      i: {
        fontSize: 23
      },
      h6: {
        fontSize: 14
      }
    },
    couponTextField: {
      borderLeft: '0!important',
      backgroundColor: '#F5F5F5',
      borderRadius: 0,
      marginTop: '2px'
    },
    couponOpenBtn: {
      height: 58,
      textAlign: 'center',
      verticalAlign: 'middle',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#F5F5F5',
      marginTop: 2
    }
  };
});

export const SearchBarMobile = (props: any) => {
  const appContext = useContext(AppContext);


  const { classes } = useStyles();
  const {t} = useTranslation();

  const [openModalDatePicker, setOpenModalDatePicker] = useState(false);
  const handleOpenModalDatePicker = () => setOpenModalDatePicker(true);

  const handleCloseModalDatePicker = () => {
    setOpenModalDatePicker(false);
    appContext.getAvailability('search bar mobile');
  };

  const [openGuestsModal, setOpenGuestsModal] = useState(false);
  const handleOpenGuestsModal = () => setOpenGuestsModal(true);

  const value = props.params.value;
  const locale = props.params.locale;
  const container = 'SearchBarMobile';
  const setQuantity = props.params.setQuantity;
  const setPets = props.params.setPets;

  useEffect(() => {
    appContext.setMobileSubmitBtn(true);
  }, [
    appContext.searchForms[appContext.orderIndex].destination,
    appContext.searchForms[appContext.orderIndex].property,
    appContext.searchForms[appContext.orderIndex].typeOfHoliday,
    appContext.searchForms[appContext.orderIndex].landscape,
    appContext.searchForms[appContext.orderIndex].GuestArrival,
    appContext.searchForms[appContext.orderIndex].GuestDeparture,
    appContext.searchForms[appContext.orderIndex].NoOfAdults,
    appContext.searchForms[appContext.orderIndex].ageOfChildren.length,
    appContext.searchForms[appContext.orderIndex].Coupon,
    appContext.searchForms[appContext.orderIndex].Pets
  ]);

  const [couponField, setCouponField] = useState<boolean>(false);

  const handleCouponField = () => {
    setCouponField(!couponField);
  }

  // @ts-ignore
  return (
    <Paper className={classes.root} elevation={0}>
      <SelectDestinationField params={{ container }} />
      <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'} mt={1}>
        <Grid
          size={{
            xs: 8,
            sm: 8,
            md: 8
          }}
          className={classes.inputPaper}
          onClick={() => handleOpenModalDatePicker()}>
          <Box sx={{ backgroundColor: '#FF0000!important' }}>
            <SelectDateField
              params={{ value, locale, handleCloseModalDatePicker, container }}
            />
          </Box>
        </Grid>

        <Grid
          size={{
            xs: 2,
            sm: 2,
            md: 2
          }}
          className={classes.inputPaper}
          onClick={() => handleOpenGuestsModal()}>
          <SetGuestsField params={{ container, setQuantity, setPets }} />
        </Grid>

        <Grid
          size={{
            xs: 2,
            sm: 2,
            md: 2
          }}
          className={classes.couponOpenBtn}
          onClick={handleCouponField}
        >
          <TicketCoupon size={20} />
        </Grid>

        {
          couponField && (
            <Grid
              size={{
                xs: 12,
                sm: 12,
                md: 12
              }}
              className={classes.couponTextField}
            >
              <SetCouponField params={{ container }} />
            </Grid>
          )
        }


        {
          appContext.mobileSubmitBtn && (
            <Grid
              size={{
                xs: 12
              }}
              mt={1}
            >

              {
                website.code !== 'VP' ? (
                  <>
                    {
                      !appContext.updateSearch ? (
                        <Button
                          id={'search'}
                          variant={'contained'}
                          type={'submit'}
                          sx={{ backgroundColor: '#000!important', color: '#FFF!important' }}
                          fullWidth>
                          {t('Start_search')}
                        </Button>
                      ) : (
                        <Button
                          id={'search'}
                          variant={'contained'}
                          type={'submit'}
                          sx={{ backgroundColor: '#000!important', color: '#FFF!important' }}
                          fullWidth>
                          {t('Update_search')}
                        </Button>
                      )
                    }
                  </>
                ) : (
                  <>
                    {
                      !appContext.updateSearch ? (
                        <Button
                          id={'search'}
                          color={'secondary'}
                          variant={'contained'}
                          type={'submit'}
                          fullWidth>
                          {t('Start_search')}
                        </Button>
                      ) : (
                        <Button
                          id={'search'}
                          color={'secondary'}
                          variant={'contained'}
                          type={'submit'}
                          fullWidth>
                          {t('Update_search')}
                        </Button>
                      )
                    }
                  </>
                )
              }


            </Grid>
          )
        }
      </Grid>
    </Paper>
  );
};
